import { applyAdditionalDiscount } from "../utils/ac-apply-additional-discount";
import { AIRCON_PRICING_PROFILES, getAirconPricingProfile } from "../data/aircon-pricing-profiles";

// Static price tables for the SEO pages. The constants used to be hardcoded
// here for Singapore; they now come from a per-country profile
// (data/aircon-pricing-profiles.js) so UAE/Malaysia pages render with the same
// formula. Every expression below keeps the exact operation order of the old
// SG-only code, so with the SG profile the output is identical to the cent.
// The optional 6th argument defaults to SG, so the ~25 existing SG callers that
// pass five arguments are unaffected.
export function airconCostCalculation(currencyCd, annualServicing, standardServicing, chemicalServicing, overhaulServicing, profile = AIRCON_PRICING_PROFILES.sg) {
    const discountPercent = profile.discountPercent;//general discount
    const standardBase = profile.base
    const chemicalBasicBase = profile.chemicalBasicBase
    const chemicalOverhaulBase = profile.chemicalOverhaulBase
    const chemicalDiscountFactor = profile.chemicalDiscountFactor
    const standardDiscountFactor = profile.generalDiscountFactor
    // const standardDiscountFactor = 15

    const intervalDiscountFactor = profile.intervalDiscountFactor

    const interval = [3, 4]

    const airconCount = 5

    const getAnnualServicingCost = (rate, x) => {
        let threeMonthRate
        let fourMonthRate
        for (let i = 0; i < interval.length; i++) {
            let annualCost = rate * interval[i]
            let annualrate = annualCost - (annualCost * (intervalDiscountFactor + (x > 5 ? 5 : x))/100);
            if (interval[i] === 3) {
                threeMonthRate = annualrate
            }
            if (interval[i] === 4) {
                fourMonthRate = annualrate
            }
        }
        threeMonthRate = threeMonthRate - threeMonthRate*discountPercent/100
        // threeMonthRate = applyAdditionalDiscount(threeMonthRate)

        fourMonthRate = fourMonthRate - fourMonthRate*discountPercent/100
        // fourMonthRate = applyAdditionalDiscount(fourMonthRate)

        let annual = { number: x + (x > 1 ? " Units" : " Unit"), currencyCd: currencyCd, "threeMonthInterval": fourMonthRate.toFixed(2), "fourMonthInterval": threeMonthRate.toFixed(2) }
        annualServicing.push(annual)
    }

    for (let x = 1; x <= airconCount; x++) {
        if (x === 1) {
            // let standardRate = (standardBase * (1 + x))
            let standardRate = (standardBase * (1 + x) + profile.firstUnitAdjustment)
            let chemicalWashRate = (chemicalBasicBase * (1 + x))
            let chemicalOverhaulRate = (chemicalOverhaulBase * (1 + x))

            getAnnualServicingCost(standardRate, x)
            //apply discount
            standardRate = standardRate - standardRate*discountPercent/100
            // standardRate = applyAdditionalDiscount(standardRate)

            chemicalWashRate = chemicalWashRate - chemicalWashRate*discountPercent/100
            // chemicalWashRate = applyAdditionalDiscount(chemicalWashRate)

            chemicalOverhaulRate = chemicalOverhaulRate - chemicalOverhaulRate*discountPercent/100
            // chemicalOverhaulRate = applyAdditionalDiscount(chemicalOverhaulRate)

            let standardClean = { number: x + (x > 1 ? " AC units" : " AC unit"), currencyCd: currencyCd, rate: standardRate.toFixed(2) }
            let chemicalWash = { number: x + (x > 1 ? " AC units" : " AC unit"), currencyCd: currencyCd, rate: chemicalWashRate.toFixed(2) }
            let chemicalOverhaul = { number: x + (x > 1 ? " AC units" : " AC unit"), currencyCd: currencyCd, rate: chemicalOverhaulRate.toFixed(2) }

            standardServicing.push(standardClean)
            chemicalServicing.push(chemicalWash)
            overhaulServicing.push(chemicalOverhaul)
        } else {
            let standardRate = (standardBase * (1 + x)) - standardDiscountFactor * (standardBase * x) / 100 - profile.unitStep * (x - 5)

            //when aircon count > 4)
            if(x > 4){
                standardRate = standardRate - profile.bulkDeduction
            }

            let chemicalWashRate = (chemicalBasicBase * (1 + x)) + chemicalDiscountFactor * (chemicalBasicBase * x) / 100
            let chemicalOverhaulRate = (chemicalOverhaulBase * (1 + x)) + chemicalDiscountFactor * (chemicalOverhaulBase * x) / 100

            getAnnualServicingCost(standardRate, x)
            //apply discount
            standardRate = standardRate - standardRate*discountPercent/100
            // standardRate = applyAdditionalDiscount(standardRate)

            chemicalWashRate = chemicalWashRate - chemicalWashRate*discountPercent/100
            // chemicalWashRate = applyAdditionalDiscount(chemicalWashRate)

            chemicalOverhaulRate = chemicalOverhaulRate - chemicalOverhaulRate*discountPercent/100
            // chemicalOverhaulRate = applyAdditionalDiscount(chemicalOverhaulRate)

            let standardClean = { number: x + (x > 1 ? " AC units" : " AC unit"), currencyCd: currencyCd, rate: standardRate.toFixed(2) }
            let chemicalWash = { number: x + (x > 1 ? " AC units" : " AC unit"), currencyCd: currencyCd, rate: chemicalWashRate.toFixed(2) }
            let chemicalOverhaul = { number: x + (x > 1 ? " AC units" : " AC unit"), currencyCd: currencyCd, rate: chemicalOverhaulRate.toFixed(2) }

            standardServicing.push(standardClean)
            chemicalServicing.push(chemicalWash)
            overhaulServicing.push(chemicalOverhaul)

        }
    }
}

// Chemical Hydro Wash rows (1-5 units, wall) in the same shape as the arrays
// airconCostCalculation fills, for the SG pages' tables. Kept out of that
// function so its ~25 callers are unchanged. [] where the market doesn't offer it.
export const hydroWashServicing = (currencyCd, profile = AIRCON_PRICING_PROFILES.sg) => {
    const base = profile.chemicalHydroBase
    if (!base) return []
    return [1, 2, 3, 4, 5].map((x) => {
        let rate = x === 1
            ? (base * (1 + x))
            : (base * (1 + x)) + profile.chemicalDiscountFactor * (base * x) / 100
        rate = rate - rate*profile.discountPercent/100
        return { number: x + (x > 1 ? " AC units" : " AC unit"), currencyCd: currencyCd, rate: rate.toFixed(2) }
    })
}

/* ------------------------------------------------------------------ *
 * Market price tables (UAE / Malaysia pages)
 * ------------------------------------------------------------------ */

const round2 = (n) => Math.round(n * 100) / 100

// Pre-discount general servicing cost for n wall units, one visit.
const generalCost = (p, n) => {
    if (n === 1) return p.base * 2 + p.firstUnitAdjustment
    let cost = p.base * (1 + n) - p.generalDiscountFactor * (p.base * n) / 100 - p.unitStep * (n - 5)
    if (n > 4) cost = cost - p.bulkDeduction
    return cost
}

const chemicalCost = (p, base, n) =>
    n === 1 ? base * 2 : base * (n + 1) + p.chemicalDiscountFactor * (base * n) / 100

const perUnitServiceCost = (p, base, n) =>
    base * n - p.generalDiscountFactor * (p.base * n) / 100 - p.unitStep * (n - 3)

/**
 * Every price an AE/MY service page can show, already discounted, as numbers
 * (format with utils/format-money at render time).
 *
 * Shape: {
 *   currency,
 *   general:   [{ units, wall, ducted, perUnitWall }],     // one visit
 *   annual:    [{ units, threeTimes, fourTimes }],         // per year, wall
 *   chemicalWash:     [{ units, wall, ducted, perUnitWall }],
 *   chemicalOverhaul: [{ units, wall, ducted, perUnitWall }],
 *   chemicalHydroWash: [{ units, wall, ducted, perUnitWall }], // [] where not offered (AE/MY)
 *   condenser: [{ units, normal, chemical }],
 *   drainFlush:[{ units, price }],
 *   gas: { R410A: { half, full }, R32: {...}, R22: {...} }, // per compressor
 *   repairDiagnosis,
 * }
 * "ducted" is the market's non-wall unit: concealed ducted in the UAE,
 * ceiling cassette in Malaysia.
 */
// StringsSG's own gas top-up prices per refrigerant, half tank to full tank, in
// the { type, priceRange } shape AirconPricing's gas table expects. AirconPricing
// sits among our own price tables, so it must not be fed market ranges.
export const gasTopupPriceRanges = (countryCd) => {
    const { gas, currency } = buildAirconPriceTables(countryCd)
    const symbol = currency === 'SGD' ? 'S$' : `${currency} `
    return Object.entries(gas).map(([type, { half, full }]) => ({
        type,
        priceRange: `${symbol}${half.toFixed(2)} - ${symbol}${full.toFixed(2)}`,
    }))
}

export const buildAirconPriceTables = (countryCd, maxUnits = 5) => {
    const p = getAirconPricingProfile(countryCd)
    const off = (v) => round2(v - v * p.discountPercent / 100)
    const units = Array.from({ length: maxUnits }, (_, i) => i + 1)

    const general = units.map((n) => {
        const g = generalCost(p, n)
        const uplift = n === 1 ? p.mountUpliftGeneralSingle : p.mountUpliftGeneralMulti
        return {
            units: n,
            wall: off(g),
            ducted: off(g + g * uplift / 100),
            perUnitWall: round2(off(g) / n),
        }
    })

    const annual = units.map((n) => {
        const g = generalCost(p, n)
        const yearly = (times) => {
            const gross = g * times
            return off(gross - gross * (p.intervalDiscountFactor + Math.min(n, 5)) / 100)
        }
        return { units: n, threeTimes: yearly(3), fourTimes: yearly(4) }
    })

    const chemical = (base) => units.map((n) => {
        const c = chemicalCost(p, base, n)
        return {
            units: n,
            wall: off(c),
            ducted: off(c + c * p.mountUpliftChemical / 100),
            perUnitWall: round2(off(c) / n),
        }
    })

    const condenser = units.map((n) => ({
        units: n,
        normal: off(perUnitServiceCost(p, p.condenserBase, n)),
        chemical: off(perUnitServiceCost(p, p.condenserChemicalBase, n)),
    }))

    const drainFlush = units.map((n) => ({
        units: n,
        price: off(perUnitServiceCost(p, p.pipeFlushBase, n)),
    }))

    // Half tank is charged at the midpoint of the range, full tank at the top -
    // same as AirconService.setAirconServicingCost on the backend.
    const gas = Object.fromEntries(
        Object.entries(p.gas).map(([refrigerant, { low, high }]) => [
            refrigerant,
            { half: off((low + high) / 2), full: off(high) },
        ])
    )

    return {
        currency: p.currency,
        general,
        annual,
        chemicalWash: chemical(p.chemicalBasicBase),
        chemicalOverhaul: chemical(p.chemicalOverhaulBase),
        chemicalHydroWash: p.chemicalHydroBase ? chemical(p.chemicalHydroBase) : [],
        condenser,
        drainFlush,
        gas,
        repairDiagnosis: off(p.repairFlat),
    }
}
